
























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwFloorAreaDiningRoom from "./FloorAreaDiningRoom.vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwFloorAreaDiningRoom: iwFloorAreaDiningRoom,
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },
    data: function() {
        return {
            pathInStoreExists: "property.diningRoom.exists",
            pathInStoreFloorAreaDiningRoom: "property.diningRoom.surface",
            checkboxes: [
                {
                    value: "hasDiningRoom",
                    label: "is_there_a_dining_room"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE","APARTMENT","HOMES_TO_BUILD","OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreFloorAreaDiningRoom);
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasDiningRoom"];
            }
        },
        isOpen: function(): boolean {
            let isOpen = false;

            if(this.valueChecked && this.valueChecked.length > 0) {
                isOpen = true;
            }
            return isOpen;
        },
        floorAreaDiningRoomInput: function(): Vue | void {
            const accordionComponent = this.$refs.floorAreaDiningRoom as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.floorAreaDiningRoomInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        }
    },
    mounted: function() {
        if (this.isDisplayed && this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStoreExists);
        }
    },
    methods: {
        updateValueFloorAreaDiningRoom: function(floorAreaDiningRoom: number): void {
            if (floorAreaDiningRoom == 0 && this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaDiningRoom) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaDiningRoom);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreFloorAreaDiningRoom, "value": floorAreaDiningRoom});
            }
        },
        updateValue: function(selectedValues:  Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.floorAreaDiningRoomInput) {
                    this.floorAreaDiningRoomInput.$data.internalInput = 0;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaDiningRoom);
            }
        }
    },
});
